import React from 'react';
import { Helmet } from 'react-helmet';

import AppWrapper from '../../components/appWrapper/appWrapper';
import { FollowUs } from '../../components/followUs/followUs';
import { Testimoninal } from '../../components/testimoninal/testimoninal';
import { TextWithHighlight } from '../../components/textWithHighlight/textWithHighlight';
import useScrollToLocation from '../../hooks/useScrollToLocation';
import BusinessBenefits from './components/businessBenefits/businessBenefits';
import Faqs from './components/faqs/faqs';
import HeroSection from './components/heroSection/heroSection';
import { PataPay } from './components/pataPay/pataPay';
import { SignUpProcess } from './components/signUpProcess/signUpProcess';
import { TrainerTestimoninal } from './components/testimoninal/testimoninal';
import { TopFeatures } from './components/topFeatures/topFeatures';

const TestimoninalTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        Why <strong>dog trainers </strong>
        trust Pata booking software
      </h2>
    </TextWithHighlight>
  );
};

const TestimoninalSubTitle = () => {
  return (
    <p style={{ maxWidth: '850px' }}>
      We think our booking platform can make a world of difference, but don't just take our word for it. Here's why dog
      trainers love using Pata to manage sessions, reduce admin and get discovered online.
    </p>
  );
};

export const BusinessTrainer = () => {
  useScrollToLocation();

  return (
    <>
      <AppWrapper>
        <HeroSection />

        <TopFeatures />

        <PataPay />

        <BusinessBenefits />
        <TrainerTestimoninal />

        <SignUpProcess />

        <Faqs />
        <FollowUs />
      </AppWrapper>
    </>
  );
};
